import React from 'react';
import { ScaleIcon } from '../../icons';

const DashboardTrustFooter = () => (
  <div className="mt-6 sm:mt-8 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-xl p-4">
    <div className="flex items-center gap-3 mb-2">
      <ScaleIcon className="h-5 w-5 shrink-0" />
      <div>
        <h3 className="text-sm font-semibold">Secure court record handling</h3>
        <p className="text-xs opacity-90">
          End-to-end encrypted · Role-based access · Ghana Judicial Service compliant
        </p>
      </div>
    </div>
  </div>
);

export default DashboardTrustFooter;
